<template>
  <div :class="`service mr-3 mb-3 ${serviceClass}`">
    <div class="row">
      <div class="col ml-4">
        <label class="service-title">{{ serviceBy }}</label>
        <div :class="`service-status ${serviceClass}`">
          <span>{{ item.statusName | defaultValue }}</span>
        </div>
        <div class="vertical-divider"></div>
      </div>
      <div class="col">
        <section class="service-column">
          <header class="service-column-name">
            <label>{{ numberIDName }}:</label>
          </header>
          <section class="service-column-value">
            <span>{{ numberIDValue | defaultValue }}</span>
          </section>
        </section>
      </div>
      <div class="col">
        <section class="service-column">
          <header class="service-column-name">
            <label>Proveedor:</label>
          </header>
          <section class="service-column-value">
            <span>{{ this.item.providerName | defaultValue }}</span>
          </section>
        </section>
      </div>
      <div class="col">
        <section class="service-column">
          <header class="service-column-name">
            <label>Tipo de Lugar:</label>
          </header>
          <section class="service-column-value">
            <span>{{ this.item.typeOfPlace | defaultValue }}</span>
          </section>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import AdmissionStatuses from "@/utils/constants/thrpiesAdmissionStatuses";
import { rpContractStatusColor } from "@/utils/constants/rp/rpContractStatus";

export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  filters: {
    defaultValue: value => {
      if (!value) return "No aplica";
      return value;
    }
  },
  computed: {
    serviceBy() {
      return this.item.isRemPro ? "Remedio Provisional" : "SAEE";
    },
    serviceClass() {
      // color for SAEE (admission status)
      if (!this.item.isRemPro) {
        switch (this.item.statusId) {
          case AdmissionStatuses.ReferidoAlDirectorCSEE:
          case AdmissionStatuses.ReferidoRechazado:
            return "brown";
          case AdmissionStatuses.ServicioRelacionadoActivo:
            return "green";
          case AdmissionStatuses.Asignado:
          case AdmissionStatuses.Admitido:
          case AdmissionStatuses.Vinculado:
            return "yellow";
          case AdmissionStatuses.NoVinculado:
          case AdmissionStatuses.NoVinculadoDenegadoRemPro:
          case AdmissionStatuses.Alertas:
            return "pink";
          case AdmissionStatuses.AprobadoEnRemedioProvisional:
            return "violet";
          default:
            return "orange";
        }
      }
      // color for REMPRO
      return rpContractStatusColor[this.item.statusId];
    },
    numberIDName() {
      return this.item.isRemPro ? "Número de Contrato" : "Número de Referido";
    },
    numberIDValue() {
      return this.item.isRemPro
        ? this.item.contractNumber
        : this.item.referralNumber;
    }
  }
};
</script>

<style>
.service {
  background: #f2f2f2;
  border-radius: 5px;
  min-height: 90px;
  width: 100%;
  border-left: 6px solid #f2f2f2;
}
.vertical-divider {
  height: 75%;
  width: 1px;
  background: #dddddd;
  position: absolute;
  right: 10%;
  top: 25%;
}
.service-column {
  position: relative;
  top: 14px;
}
.service-column-name {
  color: #727272;
}
.service-column-value {
  color: #11291b;
  font-weight: 600;
  position: relative;
  bottom: 5px;
}
.service-title {
  font-weight: bolder;
  position: relative;
  top: 8px;
  left: 5px;
}
.service .service-status {
  background: #dfdfdf;
  color: #11291b;
  text-align: center;
  line-height: 15px;
  font-weight: bolder;
  max-width: 225px;
  min-height: 45px;
  padding-top: 3px;
  border-radius: 25px;
}
.service .service-status > span {
  position: relative;
  top: 8px;
}

.service.orange {
  border-color: #f8ca80;
}
.service-status.orange {
  background: #f8ca80;
}

.service.yellow {
  border-color: #f8ea80;
}
.service-status.yellow {
  background: #f8ea80;
}

.service.pink {
  border-color: #fcc9c8;
}
.service-status.pink {
  background: #fcc9c8;
}

.service.violet {
  border-color: #ddb3d7;
}
.service-status.violet {
  background: #ddb3d7;
}

.service.green {
  border-color: #a4e5b2;
}
.service-status.green {
  background: #a4e5b2;
}

.service.brown {
  border-color: #d5b89a;
}
.service-status.brown {
  background: #d5b89a;
}
.service.turn {
  border-color: #e2e2e2;
}
.service-status.turn {
  background: #ff7058;
  width: 75px;
  border-radius: 100px;
}
</style>
